import { useCurrentUser } from "@twinkltech/curriculum-architect-domain-hooks";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { TwinklAnalyticsInitConfig } from "@twinkltech/web-analytics-ts/dist/types/config";
import { useEffect, useMemo } from "react";

import { usePageType } from "@/hooks/usePageType/usePageType";

const environment = import.meta.env.VITE_ENV;

export const useInitTwinklAnalyticsConfig = () => {
  const { data } = useCurrentUser();

  const { pageType } = usePageType();

  const { init, isInitialised, pageView, updateConfig } = useTwinklAnalytics();
  const config: TwinklAnalyticsInitConfig = useMemo(
    () => ({
      user: {
        twinklId: data?.userId ? Number(data.userId) : 0,
        language_id: data?.metadata?.language.id
          ? Number(data.metadata.language.id)
          : 0,
        career_id: data?.metadata?.careerId
          ? Number(data.metadata.careerId)
          : 0,
        county_id: data?.metadata?.countyId
          ? Number(data.metadata.countyId)
          : 0,
        country_id: data?.metadata?.country.id
          ? Number(data.metadata.country.id)
          : 0,
        userAccountCreateDate: data?.metadata?.dateCreated,
        loggedIn: Boolean(data?.userId),
        subscription: {
          sub_id: data?.metadata?.subscription?.id
            ? Number(data?.metadata?.subscription?.id)
            : 0,
          bundle: data?.metadata?.subscription?.bundle,
          offer_code: data?.metadata?.subscription?.offerCode ?? undefined,
          type_id: data?.metadata?.subscription?.typeId
            ? Number(data?.metadata?.subscription?.typeId)
            : 0,
        },
        schoolAccount: data?.schoolId ?? 0,
      },
      pageType: pageType?.type,
      environment,
      platform: "web",
    }),
    [data, pageType]
  );

  useEffect(() => {
    if (!isInitialised.current) {
      if (data) {
        init({ ...config });
      }
    }
    updateConfig({ pageType: pageType?.type });
    pageView({
      pathname: pageType?.path ?? "",
      search: pageType?.search ?? "",
    });
  }, [isInitialised, pageView, updateConfig, pageType, data, init, config]);
};
